export enum PaymentMethodEnum {
  BillSignUp = 1,
  PayAtDoor = 2,
  CreditCard = 3,
  PO = 4,
  CashCheck = 5,
}
